let context = null;

const CUES = {
    join: [[523, 0], [784, 0.09]],
    leave: [[659, 0], [440, 0.09]],
    request: [[880, 0], [880, 0.14], [1175, 0.28]]
};

export function playVoiceCue(name) {
    const notes = CUES[name];
    if (!notes || typeof window === 'undefined') return;
    try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return;
        context = context || new AudioCtx();
        const start = context.currentTime + 0.01;
        notes.forEach(([frequency, offset]) => {
            const oscillator = context.createOscillator();
            const gain = context.createGain();
            oscillator.type = 'sine';
            oscillator.frequency.value = frequency;
            gain.gain.setValueAtTime(0.0001, start + offset);
            gain.gain.exponentialRampToValueAtTime(0.08, start + offset + 0.015);
            gain.gain.exponentialRampToValueAtTime(0.0001, start + offset + 0.12);
            oscillator.connect(gain).connect(context.destination);
            oscillator.start(start + offset);
            oscillator.stop(start + offset + 0.14);
        });
    } catch (_) {
        // Cues are decorative; never break the call over them.
    }
}
